import { render, staticRenderFns } from "./PurchaseQuotes.vue?vue&type=template&id=7c4b28ca&scoped=true"
import script from "./PurchaseQuotes.vue?vue&type=script&lang=js"
export * from "./PurchaseQuotes.vue?vue&type=script&lang=js"
import style0 from "./PurchaseQuotes.vue?vue&type=style&index=0&id=7c4b28ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4b28ca",
  null
  
)

export default component.exports